module.exports = __webpack_public_path__ + "img/mockup-chart-monthly.11964cc9.png";